import React from 'react'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { DataListItem } from '@node-space/ui-components'

interface ConvertInProps {
  amountWithCurrency: string
  currencyFrom: string
  currencyTo: string
  convertedFromWallet: string
  convertedToWallet: string
  exchangeRate: number
  convertedAmountFrom: string
}

const ConvertIn = ({
  amountWithCurrency,
  currencyFrom,
  currencyTo,
  convertedFromWallet,
  convertedToWallet,
  exchangeRate,
  convertedAmountFrom,
}: ConvertInProps) => {
  const { t } = useTranslation()

  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-with-currency"
          testId="amount-with-currency"
          title={i18next.t('transactions.sideBar.paymentInAmountReceived')}
          body={amountWithCurrency}
        />
      )}
      {convertedFromWallet && (
        <DataListItem
          id="converted-from"
          testId="converted-from"
          title={i18next.t('transactions.sideBar.convertedFrom')}
          body={convertedFromWallet}
        />
      )}
      {convertedToWallet && (
        <DataListItem
          id="converted-to"
          testId="converted-to"
          title={i18next.t('transactions.sideBar.convertedTo')}
          body={convertedToWallet}
        />
      )}
      {convertedAmountFrom && (
        <DataListItem
          id="converted-amount-from"
          testId="converted-amount-from"
          title={t('wallets.searchTransaction.payInAmount')}
          body={convertedAmountFrom}
        />
      )}
      {exchangeRate && (
        <DataListItem
          id="exchange-rate"
          testId="exchange-rate"
          title={t('wallets.searchTransaction.exchangeRate')}
          body={`1 ${currencyFrom} = ${exchangeRate} ${currencyTo}`}
        />
      )}
    </>
  )
}

export default ConvertIn
